var map = {
	"./HSIDE.png": 711,
	"./Sastranetlogo.png": 692,
	"./UI.png": 514,
	"./deeplearning.png": 348,
	"./default.png": 89,
	"./gdnet.png": 888,
	"./graphviz.png": 535,
	"./helloworld.png": 800,
	"./mindful.png": 999,
	"./pytron_kit.png": 49,
	"./sastranet.png": 253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;